import { Box, Button, Heading, Stack, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setPreviousWindowRoute,
  setUserTimelineStep,
} from "../../../../Redux/userSlice";
import AadhaarCardUpload from "./AadhaarCardUpload";

const IdentificationDocument = ({ handleUserTabClicked }) => {
  const {
    aadhaarCard,
    //  pancard
  } = useSelector((store) => store.documentsDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
      alignContent={"space-between"}
      height={"100%"}
    >
      <Box>
        <Heading as="h2" size="md">
          Identification Documents
        </Heading>
        <Text color={"gray.600"} fontSize="sm" mt={2}>
          Please upload clear copy of your Aadhaar Card to verify your
          indentity. Ensure that documents are up-to-date and eligible.
        </Text>
        <Stack
          direction={{ base: "column", md: "row" }}
          spacing={1}
          mt={5}
          mb={3}
          justifyContent={"center"}
        >
          {/* <PanCardUpload cardDetails={pancard} /> */}
          <AadhaarCardUpload cardDetails={aadhaarCard} />
        </Stack>
      </Box>

      <Box display={"flex"} justifyContent={"flex-end"} columnGap={4} mt={10}>
        <Button
          colorScheme="blackAlpha"
          color={"blackAlpha.700"}
          size="sm"
          variant="outline"
          px={12}
          onClick={() => {
            navigate("/user");
            dispatch(setPreviousWindowRoute("documents"));
            dispatch(setUserTimelineStep(4));
          }}
        >
          Back
        </Button>
        <Button
          colorScheme={
            !(
              aadhaarCard
              //  && pancard
            )
              ? "blackAlpha"
              : "teal"
          }
          size="sm"
          color={
            !(
              aadhaarCard
              // && pancard
            )
              ? "blackAlpha"
              : "white"
          }
          variant="solid"
          px={12}
          onClick={() => handleUserTabClicked(1)}
          disabled={
            !(
              aadhaarCard
              // && pancard
            )
          }
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default IdentificationDocument;
